@if (!componentData?.config?.reportTarget) {
  <div class="red">
    Report source not configured
  </div>
} @else {
  @if (isLoading$ | async) {
    <div>
      Generating PDF Preview...
    </div>
  }
  <div class="grid-x">
    <div class="cell small-6"><a (click)="previousPage()"> &laquo; Back</a></div>
    <div class="cell small-6"><a class="float-right" (click)="nextPage()">Next &raquo;</a></div>
  </div>
  <ngx-extended-pdf-viewer [src]="reportSrc"
						   [textLayer]="true"
						   [showAll]="false"
						   [page]="currentPage"
						   [showToolbar]="false"
						   (pdfLoadingTask)="onProgress($event)"
						   (pdfLoaded)="onLoadComplete($event)"
						   class="display-block">
  </ngx-extended-pdf-viewer>
  <div class="grid-x margin-top">
    <div class="cell small-6"><a (click)="previousPage()"> &laquo; Back</a></div>
    <div class="cell small-6"><a class="float-right" (click)="nextPage()">Next &raquo;</a></div>
  </div>
  <div class="grid-x margin-top">
    <div class="cell large-12">
      <button (click)="download()" class="button hollow small">Download <svg-icon icon="icon-download"
      class="dark-gray"></svg-icon></button>
    </div>
  </div>
}

